import './cover-spinning.scss'

import React from 'react'

import Portal from '../portal/Portal'

export interface CoverSpinningProps {
    background: boolean
}

const CoverSpinning: React.FC = () => {
    return (
        <Portal>
            <div className="cover-spin" />
        </Portal>
    )
}

export default CoverSpinning
